export interface ClassCancelledVars {
  accountOwnerName: string;
  organizationName: string;
  programName: string;
  offeringTitle: string;
  offeringDate: string;
  organizationMessage: string;
  organizationUrl: string;
}

export const ClassCancelled = (vars: ClassCancelledVars) => ({
  subject: `Class Canceled - ${vars.organizationName}`,
  html: `<p>Dear ${vars.accountOwnerName},</p>

<p>${vars.programName} ${
    vars.offeringTitle ? vars.offeringTitle : ""
  } scheduled for ${vars.offeringDate} has been canceled.</p>

${
  vars.organizationMessage
    ? `<p id="org-message" style="white-space: pre-wrap;">${vars.organizationMessage}</p>`
    : ""
}

<p><a href="${
    vars.organizationUrl
  }">Sign in</a> to your account anytime to view & manage your enrollments.</p>

<p>Sincerely,<br />
${vars.organizationName}</p>`,
  sms: `${vars.organizationName} ${vars.programName} ${
    vars.offeringTitle ? vars.offeringTitle : ""
  } on ${vars.offeringDate} has been canceled.`,
});

export const BulkClassCancelled = (vars: ClassCancelledVars) => ({
  subject: `Classes Canceled - ${vars.organizationName}`,
  html: `<p>Dear Participants,</p>

<p>Classes scheduled for ${vars.offeringDate} have been canceled.</p>

${
  vars.organizationMessage
    ? `<p id="org-message" style="white-space: pre-wrap;">${vars.organizationMessage}</p>`
    : ""
}

<p><a href="${
    vars.organizationUrl
  }">Sign in</a> to your account anytime to view & manage your enrollments.</p>

<p>Sincerely,<br />
${vars.organizationName}</p>`,
  sms: `${vars.organizationName} classes on ${vars.offeringDate} have been canceled.`,
});
